import type { Constructor } from '@/type-utils';
import { mocked } from '@/configs';
import MOCK_NAVIGATIONS from '@/services/models/Navigation/mocks/MOCK_NAVIGATIONS';
import { NavigationModel } from '@/services/models/Navigation/NavigationModel';
import MockService, { MockState, ServiceMock } from '../MockService';
import type { NavigationService } from './NavigationService';

const initialState = {};

/**
 * A mock for the {@link NavigationService}.
 */
export default class NavigationServiceMock extends ServiceMock<NavigationService> {
  protected _state;

  /** @inheritdoc */
  public get state(): MockState {
    return this._state;
  }

  /** @inheritdoc */
  public getMock(): NavigationService {
    return MockService.getMockOf(this.service) as unknown as NavigationService;
  }

  /**
   * The constructor to initialize the mocks.
   *  @param service - The service for this mock, used to remove a circular dependency.
   */
  public constructor(private service: Constructor<NavigationService>) {
    super();
    this._state = new MockState(initialState);
    this.initializeMockedMembers(this.service);
  }

  /** @inheritdoc */
  protected initializeMockedMembers(
    service: Constructor<NavigationService>
  ): void {
    const mockEnabled: boolean = mocked.NavigationService;

    MockService.mockService(
      mockEnabled,
      service,
      {
        getNavigation: async () => {
          return MOCK_NAVIGATIONS.map((item) => NavigationModel.from(item));
        }
      },
      {},
      this.state
    );
  }
}
